import api from './api';
import TelegramWebApp from '../telegram-init';

export interface PaymentMethod {
  id: string;
  name: string;
  description: string;
  icon_url: string;
}

interface PaymentDetails {
  subscription_period: string;
  subscription_type?: string;
  payment_provider?: string;
  payment_url?: string;
  cryptomus_payment_id?: string;
}

export interface Payment {
  id: string;
  user_id: string;
  payment_method_id: string;
  amount: number;
  currency: string;
  status: 'pending' | 'completed' | 'failed';
  transaction_id?: string;
  payment_details: PaymentDetails;
  invoice_url?: string;
  created_at?: string;
  updated_at?: string;
}

interface InvoiceLinkResponse {
  invoiceLink: string;
}

class PaymentService {
  async createStarsPayment(amount: number, period: string): Promise<InvoiceLinkResponse> {
    const telegramId = TelegramWebApp.initDataUnsafe.user?.id;
    
    if (!telegramId) {
      throw new Error('User ID not found');
    }

    const response = await api.post<InvoiceLinkResponse>('/api/v1/payments/create-invoice', {
      title: `Premium Subscription ${period} Months`,
      description: `Access to premium features for ${period} months`,
      payload: JSON.stringify({
        period,
        telegram_id: telegramId,
        chatId: telegramId,
      }),
      prices: [{
        label: `${period} Months Premium`,
        amount: amount // Use original amount
      }]
    });
    return response.data;
  }

  async createCryptoPayment(amount: number, period: string, return_to: string, payment_method: string = 'crypto'): Promise<Payment> {
    const response = await api.post<Payment>('/api/v1/payments/create-crypto', {
      amount,
      period,
      currency: 'USD',
      return_to,
      payment_method
    });
    return response.data;
  }

  async getCryptoPayment(paymentId: string): Promise<Payment> {
    const response = await api.get<Payment>(`/api/v1/payments/crypto/${paymentId}`);
    return response.data;
  }

  async checkCryptoPaymentStatus(paymentId: string): Promise<Payment> {
    const response = await api.get<Payment>(`/api/v1/payments/crypto/${paymentId}/status`);
    return response.data;
  }
}

export const paymentService = new PaymentService();